import DimensionSpecification from "../../dimensionSpecification/DimensionSpecification.js";
import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * Wraps another node to represent its value in the context of a
 * dimension specification.
 *
 * @param {specification} [spec.dimensionSpecification] - dimension specification
 */
export default class DimensionFormulaNode extends WrapperFormulaNode {
	constructor({ dimensionSpecification }) {
		super(...arguments);
		this._dimensionSpecification = dimensionSpecification;
	}

	getDimensionSpecification() {
		return this._dimensionSpecification;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitDimensionNode(this, additionalInformation);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.dimensionSpecification = this._dimensionSpecification;

		return properties;
	}

	static getType() {
		return "DimensionNode";
	}

	static build(builder, additionalInformation) {
		return builder.buildDimensionNode(this, additionalInformation);
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.dimensionSpecification = DimensionSpecification.materialize(
			data.dimensionSpecification,
			context,
		);
	}
}
